<div class="flex flex-wrap gap-3 p-3">

  <div *ngFor="let group of navigationGroup" class="shadow-3 p-3 border-round-sm w-20rem">
      <div class="flex align-items-center rem-text-default mb-2">
          <div class="rem-bg-light p-3 mr-2">
            <i class="pi pi-{{group.icon}} font-medium"></i>
          </div>
          <div>
            <div class="font-bold">{{group.label}}</div>
            <div class="text-xs">{{group.description}}</div>
          </div>          
       </div>  
        
       <div *ngFor="let item of group.children" class="flex">
          <a [routerLink]="['/'+item.link]" class="flex align-items-center gap-1 p-1 text-600 no-underline rem-text-hover-bg">
            <i class="pi pi-{{item.icon}}"></i>
            <div>{{item.label}}</div>
          </a>
       </div>
  </div>

</div>
